import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsSymfonyComponent } from './simple-icons-symfony.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsSymfonyComponent ],
    exports:      [ SimpleIconsSymfonyComponent ],
    bootstrap:    []
})
export class SimpleIconsSymfonyModule {}
